import { MODALS, EVENTS } from 'common/domain/constants';
import { LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG } from 'loans.module/common/domain/constants.loans';

const STEPS = {
  FORM: 'form',
  RESUME: 'resume',
};

const MODALS_WAGE_ADVANCE = {
  SUCCESS: 'success',
  FAILED: 'failed',
  CUESTION: 'cuestion',
  SUCCESS_DELETE: 'success-delete',
  FAILED_DELETE: 'failed-delete',
};

class WageAdvanceController {

  constructor($log, $window, $q, $stateParams, $rootScope, wageAdvanceService, wageAdvanceHelper, LoansUserDataService, loadingMobileService) {
    'ngInject';
    this.log = $log;
    this.window = $window;
    this.q = $q;
    this.rootScope = $rootScope;
    this.stateparams = $stateParams;

    this.wageAdvanceService = wageAdvanceService;
    this.wageAdvanceHelper = wageAdvanceHelper;
    this.loansUserDataService = LoansUserDataService;
    this.loadingMobileService = loadingMobileService;

    this.isMobileApp = $window.innerWidth < 1024;
    this.userId = this.loansUserDataService._employee.userId;
    this.wageAdvanceReasonsList = [];
    this.employeeWagesAdvance = [];
    this.step = STEPS.FORM;
    this.loaded = false || this.isMobileApp;
    this.coachmarkData = LOANS_WAGE_ADVANCE_MODAL_COACHMARK_CONFIG;

    this.init();
  }

  init() {
    this.checkLoansAccess();
    this.loadingMobileService.show();
    this.q.all([
      this.wageAdvanceService.getReasonsList(),
      this.wageAdvanceService.getEmployeeWagesAdvance(this.userId)
    ]).then(responses => {
      this.wageAdvanceReasonsList = responses[0];
      this.log.info('Wage advance reasons list is:', this.wageAdvanceReasonsList);

      let employeeWagesAdvance = responses[1];
      this.log.info('Employee list is:', employeeWagesAdvance);
      this.employeeWagesAdvance = this.wageAdvanceHelper.format(employeeWagesAdvance);
      this.loaded = true;
    }, error => {
      this.log.error('WageAdvanceController init()', error);
      // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
      // this.state.go(STATES.ERROR);
    }).finally(()=> {
      this.loadingMobileService.hide();
    });
  }

  checkLoansAccess(){
    this.withoutLoansAccess = this.stateparams.stateAccess;
    if(this.withoutLoansAccess){
      this.rootScope.$emit(EVENTS.WITHOUT_LOANS_ACCESS);
    }
  }

  get modal() {
    return $(MODALS.WAGE_ADVANCE_MODAL);
  }

  getClasses() {
    return {
      'responsiveMobile': this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp
    };
  }

  checkServiceClosed() {
    return this.serviceClosed;
  }

  setWadgeAdvance($event) {
    this.wageAdvance = $event;
    this.log.info('Wadge advance is:', this.wageAdvance);
    this.step = STEPS.RESUME;
  }

  isForm() {
    return this.step === STEPS.FORM;
  }

  isResume() {
    return this.step === STEPS.RESUME;
  }

  onCancel($event) {
    this.cancelAdvance = $event;
    this.log.info('Cancel advance:', $event);
    this.openModal(MODALS_WAGE_ADVANCE.CUESTION);
  }

  cancelResume() {
    this.step = STEPS.FORM;
  }

  cancelWageAdvance() {
    this.loadingMobileService.show();
    const wageAdvance = this.cancelAdvance.advance;
    this.wageAdvanceService.deleteWageAdvance(this.userId, wageAdvance)
      .then(() => {
        this.openModal(MODALS_WAGE_ADVANCE.SUCCESS_DELETE);
      }, error => {
        this.messageError = error.data.message;
        this.openModal(MODALS_WAGE_ADVANCE.FAILED_DELETE);
      }).finally(()=> {
        this.loadingMobileService.hide();
      });
  }

  finishWageAdvance($event) {
    this.loadingMobileService.show();
    this.wageAdvanceService.postWagesAdvance(this.userId, $event)
      .then(() => {
        this.openModal(MODALS_WAGE_ADVANCE.SUCCESS);
      }, error => {
        this.messageError = error.data.message;
        this.openModal(MODALS_WAGE_ADVANCE.FAILED);
      }).finally(()=> {
        this.step = STEPS.FORM;
        this.loadingMobileService.hide();
      });
  }

  openModal(modal) {
    this.modalToShow = modal;
    this.modal.modal('show');
  }

  closeModal() {
    const isSuccess = this.modalToShow === MODALS_WAGE_ADVANCE.SUCCESS;
    const isSuccessDelete = this.modalToShow === MODALS_WAGE_ADVANCE.SUCCESS_DELETE;
    const closeNeedToRefresh = isSuccess || isSuccessDelete;

    if (closeNeedToRefresh) {
      return this.init();
    }

    this.step = STEPS.FORM;
    this.cancelAdvance = null;
    this.modal.modal('hide');
  }

}

export default WageAdvanceController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvance.controller.js